import React from "react";
import { KIA_GRIDS } from "@/components/KiaConditionsPanel";

export const KiaResult = ({ result, formatCurrency, calcPercent }) => {
  const rows = [["base", "Marge de base", result.base_margin]];
  if (result.sale_category === "SOCIETE") rows.push(["company", `Support KFR · ${KIA_GRIDS.find(g => g.value === result.company_type)?.label || result.company_type}`, result.company_aid]);
  else if (result.sale_category === "VD") {
    rows.push(["prime", "Prime KFR applicable", result.kia_vd_systematic_prime]);
    rows.push(["vd", "Mise à la route VD · 3 %", result.kia_vd_bonus_3pct]);
  } else if (result.sale_category === "VDR") rows.push(["vdr", "Aide VDR", result.vdr_aid]);
  else rows.push(["prime", `Participation KFR ${result.has_kialiberty ? "KiaLiberty [12]" : "Particulier [11]"}`, result.systematic_prime]);
  if (result.trade_in_bonus > 0) rows.push(["trade", "Prime reprise / renouvellement", result.trade_in_bonus]);
  if (result.exceptional_aid > 0) rows.push(["exceptional", "Aide exceptionnelle", result.exceptional_aid]);
  return rows.map(([key,label,amount]) => <div key={key} data-testid={`kia-result-${key}-row`} className="flex flex-wrap justify-between gap-2">
    <span>{label}</span><span data-testid={`kia-result-${key}-amount`} className="font-data">{formatCurrency(amount)} <span className="text-xs text-muted-foreground">{calcPercent(amount)}</span></span>
  </div>);
};